export const TABS = [
  {
    key: '1',
    label: 'Investor Clients',
  },
  {
    key: '2',
    label: 'Home Buyers',
  },
];

export const TAB_TO_DATA_KEY = {
  1: 'Investors',
  2: 'Home Buyers',
};
